import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fontWeight={400} fontFamily="sans-serif" fill="#2e3436"><path d="M8 1a3 3 0 00-3 3v.361c.396-.45.893-.818 1.469-1.056a3.925 3.925 0 011.271-.27A.988.988 0 018 3c.035 0 .069.01.104.014.033 0 .066-.008.1-.006.968.05 1.91.45 2.624 1.164.063.063.114.133.172.199V4a3.003 3.003 0 00-3-3zM4 5v2c0-.72.204-1.402.55-2zm7.453 0a4.002 4.002 0 01.242 3.531c-.337.815-.97 1.397-1.695 1.826V11h2V5zm-3.351.004a1.993 1.993 0 00-.868.148c.317-.13.656-.133.987-.095-.044-.005-.075-.05-.12-.053zm-1.405.498A2.227 2.227 0 006.305 6h.002c.108-.184.238-.353.392-.498h-.002zm3.069.56zM4 8v3h2V9c0-.387.222-.691.418-1zm4.793.756C8.539 8.87 8.287 9 8 9v.115l.664-.236c.058-.02.073-.098.129-.123zM2 13v2h6c-1.093 0-2-.907-2-2zm6 2h6v-2h-4c0 1.093-.907 2-2 2z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
        marker: "none"
      }} color="#bebebe" overflow="visible" opacity={0.35} /><path d="M8.152 4.006A2.992 2.992 0 005 7h2c0-.408.24-.768.617-.924a.994.994 0 011.09.217.994.994 0 01.217 1.09A.994.994 0 018 8a1 1 0 00-1 1v2h2V9.82a2.998 2.998 0 001.771-1.672 3.006 3.006 0 00-.65-3.27 3.001 3.001 0 00-1.969-.872zM8 12a1 1 0 00-1 1 1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1
      }} color="#000" overflow="visible" /></g></svg>;
}

export default SvgComponent;